import { ButtonStyleCheckbox, ButtonStyleCheckboxGroup, CheckboxGroup } from '@uplift/ui-v2';
import { useQuery } from '@tanstack/react-query';
import { getTherapyTypes } from '@uplift/api';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { filterOutGroupModality } from '@uplift/utils';

export type TypesOfTherapyFormProps = {
  enableButtonStyle?: boolean;
};

export const TypesOfTherapyForm: React.VFC<TypesOfTherapyFormProps> = props => {
  const { data: therapyTypes = [], isInitialLoading: loading } = useQuery({
    queryKey: PROFILE_ROW_QUERY_KEYS.modalities,
    queryFn: async () => {
      const response = await getTherapyTypes();

      return response.therapyTypes.filter(filterOutGroupModality);
    }
  });

  if (props.enableButtonStyle) {
    return (
      <div>
        <ButtonStyleCheckboxGroup name="therapyTypes">
          {therapyTypes.map(({ name, id }) => (
            <ButtonStyleCheckbox value={id} key={id} label={name} />
          ))}
        </ButtonStyleCheckboxGroup>
      </div>
    );
  }

  return (
    <div>
      <CheckboxGroup
        name="therapyTypes"
        options={therapyTypes.map(({ name, id }) => ({ label: name, value: id }))}
        loading={loading}
      />
    </div>
  );
};
